import { Component, OnInit } from '@angular/core';

@Component({ standalone: false,
  selector: 'vfa-cp-flow-error',
  templateUrl: './flow-error.component.html',
  styleUrls: ['./flow-error.component.scss'],
})
export class FlowErrorComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}

